<template>
    <el-dialog :visible.sync="visible" title="查看关联" :close-on-click-modal="false" :close-on-press-escape="false"
        append-to-body>
        <el-table v-if="dataForm.taskType == '3'" max-height="600" v-loading="dataListLoading" :data="dataList" border
            @selection-change="dataListSelectionChangeHandle" @sort-change="dataListSortChangeHandle" style="width: 100%">
            <!--                <el-table-column type="selection" header-align="center" align="center" width="50"></el-table-column>-->
            <el-table-column prop="id" label="残协编号" header-align="center" align="center"></el-table-column>
            <el-table-column prop="updater" label="残协名称" header-align="center" align="center"></el-table-column>
            <el-table-column prop="handicappedXm" label="专职委员" header-align="center" align="center"></el-table-column>
            <el-table-column prop="handicappedMobile" label="联系电话" header-align="center" align="center"></el-table-column>
            <el-table-column prop="cun" label="村名称" header-align="center" align="center"></el-table-column>
            <el-table-column label="操作" fixed="right" header-align="center" align="center">
                <template slot-scope="scope">
                    <el-button type="text" size="small"
                        @click="lookDetail(scope.row.id, scope.row.taskType)">任务情况</el-button>
                    <el-button type="text" size="small" @click="deleteHandle(scope.row.id)">删除</el-button>
                </template>
            </el-table-column>
        </el-table>
        <el-table v-if="dataForm.taskType != '3'" max-height="600" v-loading="dataListLoading" :data="dataList" border
            @selection-change="dataListSelectionChangeHandle" @sort-change="dataListSortChangeHandle" style="width: 100%">
            <!--                <el-table-column type="selection" header-align="center" align="center" width="50"></el-table-column>-->
            <el-table-column prop="id" label="残协编号" header-align="center" align="center"></el-table-column>
            <el-table-column prop="handicappedXm" label="姓名" header-align="center" align="center"></el-table-column>
            <el-table-column prop="cxName" label="残协名称" header-align="center" align="center"></el-table-column>
            <!-- <el-table-column prop="handicappedXm" label="专职委员" header-align="center" align="center"></el-table-column> -->
            <el-table-column prop="handicappedMobile" label="联系电话" header-align="center" align="center"></el-table-column>
            <el-table-column prop="cun" label="村名称" header-align="center" align="center"></el-table-column>
            <el-table-column label="操作" fixed="right" header-align="center" align="center">
                <template slot-scope="scope">
                    <el-button type="text" size="small"
                        @click="lookDetail(scope.row.id, scope.row.taskType)">任务情况</el-button>
                    <el-button type="text" size="small" @click="deleteHandle(scope.row.id)">删除</el-button>
                </template>
            </el-table-column>
        </el-table>
        <!-- 查看任务情况 -->
        <condition-detail v-if="OpenViewAssociation" ref="ViewAssociation" :appendToBody="true"></condition-detail>
    </el-dialog>
</template>

<script>
import debounce from "lodash/debounce";
import mixinViewModule from "@/mixins/view-module";
import conditionDetail from "../result/conditionDetail";
export default {
    mixins: [mixinViewModule],
    components: {
        conditionDetail,
    },
    data() {
        return {
            mixinViewModuleOptions: {
                getDataListURL: "/task/resultList",
                deleteURL: "/task/deleteRelate",
                activatedIsNeed: true,
            },
            visible: false,
            dataForm: {
                taskId: "",
            },
            OpenViewAssociation: false,
        };
    },
    computed: {},
    created() { },
    methods: {
        init(id) {
            this.dataForm.taskId = id.toString();
            this.query();
            this.visible = true;
            //   this.$nextTick(() => {
            //     this.$refs["dataForm"].resetFields();
            //     if (this.dataForm.id) {
            //       this.getInfo();
            //     }
            //   });
        },
        deleteHandle(id) {
            //删除关联
            this.$confirm("确定进行删除操作？", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    axios
                        .get(
                            this.$baseURL+"/api/task/deleteRelate",
                            {
                                params: {
                                    id: id,
                                },
                            },

                            { headers: { "content-type": "application/json" } }
                        )
                        .then(({ data: res }) => {
                            if (res.code !== 0) {
                                return this.$message.error(res.msg);
                            }
                            this.$message({
                                message: "操作成功",
                                type: "success",
                                duration: 500,
                                onClose: () => {
                                    this.query();
                                },
                            });
                        })
                        .catch(() => { });
                })
                .catch(() => { });
        },
        lookDetail(id, taskType) {
            //查看详情
            this.OpenViewAssociation = true;
            this.$nextTick(() => {
                this.$refs.ViewAssociation.init(id, taskType);
            });
        },
    },
};
</script>
